import { ts } from '_core';

import { getName, validate } from './helpers';
import { INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_RELATIVE_RETURNS,
    title: 'Relative Returns',
    helpLabel: 'azcj837a',
    form: true,
    defaultParams: {
      format_for_ui: true,
    },
    interactionParams: Object.values(INTERACTION_PARAMS),
    neededFiles: ['signal_relative_returns'],
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL],

    getName,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
